<template>
  <manage-members
    :initial-members="teamMembers"
    :profiles="profiles"
    @change="$emit('change', $event)"
  >
    <template #search-label>
      Search and add team members
    </template>
    <template #current-label>
      Current team members
    </template>
  </manage-members>
</template>

<script>
import ManageMembers from '@/components/common/ManageMembers'

export default {
  name: 'ManageTeamMembers',

  props: {
    team: {
      type: Object,
      required: true
    },

    profiles: {
      type: Object,
      required: true
    }
  },

  computed: {
    teamMembers() {
      return this.team.members.map(member => ({
        canDelete: !member.isManager,
        profileId: member.profile
      }))
    }
  },

  components: {
    ManageMembers
  }
}
</script>
